import React from 'react';
import { demoPagesMenu, pageLayoutTypesPagesMenu } from '../menu';
import MekaAside from '../pages/MekaAside';
const asides = [
    { path: '*', element: <MekaAside /> },
];
export default asides;
